import { API_BASE } from "@/lib/api";
import { resolveBrandingAssetUrl } from "@shared/brandingAssetUrl";

type BookingBrandHeaderProps = {
  siteName: string;
  logoUrl?: string | null;
  title?: string;
  subtitle?: string;
  className?: string;
};

export function BookingBrandHeader({
  siteName,
  logoUrl,
  title,
  subtitle,
  className = "",
}: BookingBrandHeaderProps) {
  const resolvedLogoUrl = resolveBrandingAssetUrl(logoUrl, API_BASE);
  return (
    <header className={`mb-6 text-center ${className}`.trim()}>
      <div className="mb-4 flex flex-col items-center gap-2">
        {resolvedLogoUrl ? (
          <img
            src={resolvedLogoUrl}
            alt={siteName}
            className="max-h-12 max-w-[12rem] object-contain"
            loading="lazy"
          />
        ) : null}
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-600">
          {siteName}
        </p>
      </div>
      {title ? (
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">{title}</h1>
      ) : null}
      {subtitle ? (
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-slate-600">{subtitle}</p>
      ) : null}
    </header>
  );
}
